export default __webpack_public_path__ + "assets/d9a02fc1abe21a468f9abfe8db9240ab.svg";